import { urlWithParams } from '@marketplace-web/shared/utils'

export const USER_PERSONALIZATION_SIZES_URL = '/member/personalization/sizes'
export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const PROFILE_SETTINGS_URL = '/settings/profile'
export const DONATIONS_SETTINGS_URL = '/settings/donations'
export const ROOT_URL = '/'
export const GO_TO_WALLET_URL = '/wallet/balance'
export const MY_ORDERS_URL = '/my_orders'
export const REFERRALS_URL = '/referrals'
export const WALLET_INVOICES_URL = '/wallet/invoices'
